var ccww = $(window).width();
if(ccww >= 992){
    var PD = {
        selectors:{
            productGroup: {
                wrap: ".pg",
                mainsSlider: ".pg__mains--slider"
            },
            slider: {
                overFloatClasses: "ov-slider-tb ov-slider-mb hide-in-loading"
            }
        },
    options: {
        productGroup: {
            mainSlider: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                fade: !1,
                infinite: !1,
                swipeToSlide: !0,
                arrows: !0,
                adaptiveHeight: !0,
                lazyLoad: "ondemand",
                rtl: rtl,
                nextArrow: '<button aria-label="button" class="slick-next slick-arrow--ver-center flex flex-align-ver flex-align-hoz button--shadow" type="button"><i class="slick-arrow__icon slick-arrow__icon--next"></i></button>',
                prevArrow: '<button aria-label="button" class="slick-prev slick-arrow--ver-center flex flex-align-ver flex-align-hoz button--shadow" type="button"><i class="slick-arrow__icon slick-arrow__icon--prev"></i></button>',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        dots: !1,
                        arrows: !1
                    }
                }]
            }
        }
    },
    loadCssJsLib: function(t, e) {
        if (theme.loadedLibs.indexOf(t) > -1)
            e && e();
        else if (null != theme.libs[t]) {
            const s = theme.libs[t].css
              , i = theme.libs[t].js;
            null != s && -1 == theme.loadedCssLibs.indexOf(t) && (theme.loadedCssLibs.push(t),
            $.each(s, ( (t, e) => {
                $("<link/>", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: "https:" + e
                }).appendTo("head")
            }
            ))),
            null != i ? null == theme.pendingJsLibs[t] ? (theme.pendingJsLibs[t] = [],
            $.getScript("https:" + i).then(( () => {
                theme.loadedLibs.push(t),
                e && e(),
                $.each(theme.pendingJsLibs[t], ( (e, s) => {
                    s(),
                    delete theme.pendingJsLibs[t][e]
                }
                ))
            }
            ))) : e && theme.pendingJsLibs[t].push(e) : (theme.loadedLibs.push(t),
            e && e())
        }
    },
        convertStrToObject: t => "string" == typeof t ? $(t) : t,
        preInitSlider: function(t, e) {
            const s = this.convertStrToObject(t);
            var i = this.selectors.slider.overFloatClasses;
            e && (i += " hide"),
            s.find("." + i.replace(/ /g, ",.")).removeClass(i)
        },
        initProductMainSlider: function(wrap) {
            const options = this.options.productGroup;
            const selector = this.selectors.productGroup;
            if(wrap.find(selector.mainsSlider).length > 0) {
                wrap.find(selector.mainsSlider).each((index, mainSliderEle) => {
                    this.loadCssJsLib('slider', () => {
                        var optionsSlider = {};
                        const mainSlider = $(mainSliderEle);
                        if(!mainSlider.hasClass('slick-initialized')){
                            $.extend(true, optionsSlider, options.mainSlider);
                            this.preInitSlider(mainSlider, true);
                            mainSlider.slick(optionsSlider);
                        }
                    });
                });
            }
        }
    };
    var PD_t = PD.selectors.productGroup.wrap, PD_e = $(PD_t);
    PD.initProductMainSlider(PD_e);
}